"use client";

import { c as _c } from "react/compiler-runtime";
import GroupAssignmentPanel from "@/components/groups/assignment/GroupAssignmentPanel";
import type { CreateWaveGroupInlinePanelProps } from "./useCreateWaveGroupInlinePanel";
export default function CreateWaveGroupInlinePanel(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <GroupAssignmentPanel {...props} layout="inline" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}